import type { PartnerComponents } from 'config/types';
import type { EstimatorSheetContentProps } from 'packages/shared/pricing/EstimatorSheetContent/types';
import { lazyWithPreload } from 'utils/bundle';
import { getPartnerSpecificComponent } from 'utils/helpers';

const CareemEstimatorSheetContent = lazyWithPreload(() => import('packages/careem/pricing/EstimatorSheetContent'));
const SharedEstimatorSheetContent = lazyWithPreload(() => import('packages/shared/pricing/EstimatorSheetContent'));

export const timeslotSelectorComponents: PartnerComponents<EstimatorSheetContentProps> = {
  CAREEM: CareemEstimatorSheetContent,
  INSTASHOP: SharedEstimatorSheetContent,
  Default: CareemEstimatorSheetContent,
};

export const EstimatorSheetContentModule = getPartnerSpecificComponent(timeslotSelectorComponents);
